import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
import { processLegacyChartModelToCustomChartModel } from '../../../utils/chart-model-adaptor.util';
import { getIsChartSettingsV2EnabledValue } from '../../../utils/chart-settings/custom-chart-schema-hydrator.util';
import { buildCustomVisualProps } from '../../../utils/chart-settings/custom-visual-props';
import { fetchDataForQueries } from '../get-data-query';
import { triggerChartReRender } from '../trigger-chart-re-render';
export const triggerUpdateChartModel = async (commonProps, eventProps, emitEvent) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    const { chartModel, renderComplete, options, visualPropEditorDefinition, } = eventProps;
    const data = await fetchDataForQueries(commonProps, eventProps, emitEvent);
    let updatedChartModel = chartModel;
    if (_.isEmpty(chartModel.customVisualProps) && visualPropEditorDefinition) {
        const isChartSettingsV2Enabled = getIsChartSettingsV2EnabledValue(options?.appConfig);
        updatedChartModel = {
            ...chartModel,
            customVisualProps: buildCustomVisualProps({
                isChartSettingsV2Enabled,
                visualPropEditorDefinition,
                chartModel,
                existingCustomVisualProps: chartModel.customVisualProps,
            }),
        };
    }
    const customChartModel = processLegacyChartModelToCustomChartModel({
        ...updatedChartModel,
    }, data);
    const payload = {
        eventType: TSToChartEvent.ChartModelUpdate,
        payload: {
            chartModel: customChartModel,
        },
    };
    return sendMessage(iframeRef, payload, appUrl).then((res) => {
        if (res.data.triggerRenderChart === true && renderComplete === true) {
            return triggerChartReRender(commonProps);
        }
        return res;
    });
};
//# sourceMappingURL=index.js.map